(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gxp-sticky-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
    let current;
    const mount = () => {
      const template = document.getElementById('gxp-purchase-dock-template');
      const host = document.querySelector('product-info[id^="MainProduct-"]');
      const info = host?.querySelector('[id^="ProductInfo-"]');
      if (!template || !info || current?.host === host) return;
      const nativeForm = info.querySelector('product-form');
      const controls = nativeForm?.parentElement;
      const submit = nativeForm?.querySelector('[id^="ProductSubmitButton-"]');
      if (!submit || controls?.parentElement !== info) return;
      current?.dispose();
      const dock = template.content.firstElementChild.cloneNode(true);
      const picker = info.querySelector('variant-selects');
      const description = info.querySelector('.product__description');
      const title = dock.querySelector('.gxp-purchase-dock__title');
      const priceSlot = dock.querySelector('.gxp-purchase-dock__price');
      const desktopQuery = window.matchMedia('(min-width: 750px)');
      const spacer = document.createElement('div');
      spacer.className = 'gxp-purchase-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      if (picker) dock.querySelector('.gxp-purchase-dock__options').append(picker);
      dock.querySelector('.gxp-purchase-dock__actions').append(controls);
      info.insertBefore(dock, description);
      info.classList.add('gxp-purchase-info');
      info.parentElement.classList.add('gxp-purchase-frame');
      document.body.append(spacer);
      document.documentElement.classList.add('gxp-purchase-active');
      let lastPrice;
      let readingPosition;
      let restoreFrame;
      let clipFrame;
      const updateClip = () => {
        clipFrame = undefined;
        if (!description) return;
        if (!desktopQuery.matches) {
          description.style.removeProperty('--gxp-purchase-clip-bottom');
          return;
        }
        const bounds = description.getBoundingClientRect();
        const cutoff = dock.getBoundingClientRect().top - 16;
        const hiddenBottom = Math.ceil(Math.min(bounds.height, Math.max(0, bounds.bottom - cutoff)));
        description.style.setProperty('--gxp-purchase-clip-bottom', `${hiddenBottom}px`);
      };
      const queueClip = () => {
        if (desktopQuery.matches && clipFrame === undefined) clipFrame = window.requestAnimationFrame(updateClip);
      };
      const revealFocusedContent = event => {
        if (!desktopQuery.matches || !event.target.getBoundingClientRect) return;
        const bounds = event.target.getBoundingClientRect();
        const cutoff = dock.getBoundingClientRect().top - 24;
        if (bounds.bottom > cutoff) {
          window.scrollBy({top: bounds.bottom - cutoff, left: 0, behavior: 'instant'});
          updateClip();
        }
      };
      window.addEventListener('scroll', queueClip, {passive: true});
      window.addEventListener('resize', queueClip, {passive: true});
      description?.addEventListener('focusin', revealFocusedContent);
      const cancelRestore = () => {
        readingPosition = undefined;
        window.cancelAnimationFrame(restoreFrame);
      };
      const rememberReading = event => {
        if (!desktopQuery.matches || !event.target.closest('variant-selects')) return;
        cancelRestore();
        readingPosition = {top: window.scrollY, time: Date.now()};
      };
      dock.addEventListener('change', rememberReading, true);
      window.addEventListener('wheel', cancelRestore, {passive: true});
      window.addEventListener('pointerdown', cancelRestore, {passive: true});
      window.addEventListener('keydown', cancelRestore);
      const sync = () => {
        const source = info.querySelector('[id^="price-"]');
        const newTitle = info.querySelector('h1')?.textContent.trim();
        const languageLabel = document.getElementById('FooterLanguageLabel')?.textContent.trim();
        if (languageLabel) {
          dock.querySelectorAll('variant-selects .product-form__input').forEach(group => {
            const choices = Array.from(group.querySelectorAll('input[type="radio"], option'));
            const label = group.querySelector('legend, .form__label');
            const isLanguage = choices.length > 0 && choices.every(choice => /^(?:ITA|ENG|FRA|GER|DEU|SPA|ESP|IT|EN|FR|DE|ES)\s*[-–]/i.test(choice.value.trim()));
            if (isLanguage && label && label.textContent.trim() !== languageLabel) label.textContent = languageLabel;
          });
        }
        if (newTitle && title.textContent !== newTitle) {
          title.textContent = newTitle;
          dock.setAttribute('aria-label', newTitle);
        }
        if (source && source.innerHTML !== lastPrice) {
          lastPrice = source.innerHTML;
          const price = source.cloneNode(true);
          price.removeAttribute('id');
          price.removeAttribute('role');
          price.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
          priceSlot.replaceChildren(price);
        }
        if (readingPosition && !submit.disabled) {
          const position = readingPosition;
          readingPosition = undefined;
          restoreFrame = window.requestAnimationFrame(() => {
            if (!dock.isConnected || !desktopQuery.matches || Date.now() - position.time > 5000) return;
            window.scrollTo({top: position.top, left: window.scrollX, behavior: 'instant'});
          });
        }
      };
      const measure = () => {
        document.documentElement.style.setProperty('--gxp-purchase-height', `${Math.ceil(dock.getBoundingClientRect().height)}px`);
        updateClip();
      };
      const placeDock = () => {
        cancelRestore();
        if (desktopQuery.matches) info.append(dock);
        else info.insertBefore(dock, description);
        measure();
      };
      sync();
      placeDock();
      desktopQuery.addEventListener('change', placeDock);
      const sizeObserver = new ResizeObserver(measure);
      sizeObserver.observe(dock);
      if (description) sizeObserver.observe(description);
      const contentObserver = new MutationObserver(sync);
      contentObserver.observe(host, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled']});
      current = {
        host,
        dispose() {
          cancelRestore();
          window.cancelAnimationFrame(clipFrame);
          window.removeEventListener('scroll', queueClip);
          window.removeEventListener('resize', queueClip);
          description?.removeEventListener('focusin', revealFocusedContent);
          description?.style.removeProperty('--gxp-purchase-clip-bottom');
          dock.removeEventListener('change', rememberReading, true);
          window.removeEventListener('wheel', cancelRestore);
          window.removeEventListener('pointerdown', cancelRestore);
          window.removeEventListener('keydown', cancelRestore);
          desktopQuery.removeEventListener('change', placeDock);
          sizeObserver.disconnect();
          contentObserver.disconnect();
          spacer.remove();
          document.documentElement.classList.remove('gxp-purchase-active');
          document.documentElement.style.removeProperty('--gxp-purchase-height');
        }
      };
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once: true});
    else mount();
    document.addEventListener('shopify:section:load', mount);
    document.addEventListener('shopify:section:unload', () => {
      if (current && !current.host.isConnected) {
        current.dispose();
        current = undefined;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
